import React, { useState, useEffect, Suspense } from 'react';
import { Box, CircularProgress } from '@mui/material';

interface OptimizedTabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
  lazy?: boolean;
  loadingComponent?: React.ReactNode;
}

const OptimizedTabPanel: React.FC<OptimizedTabPanelProps> = ({
  children,
  index,
  value,
  lazy = true,
  loadingComponent = (
    <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
      <CircularProgress />
    </Box>
  ),
}) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [shouldRender, setShouldRender] = useState(false);

  useEffect(() => {
    if (value === index) {
      setShouldRender(true);
      if (!isLoaded) {
        setIsLoaded(true);
      }
    }
  }, [value, index, isLoaded]);

  if (value !== index) {
    return null;
  }

  if (lazy && !shouldRender) {
    return null;
  }

  return (
    <div
      role="tabpanel"
      id={`optimized-tabpanel-${index}`}
      aria-labelledby={`optimized-tab-${index}`}
    >
      <Suspense fallback={loadingComponent}>
        <Box sx={{ py: 2 }}>
          {children}
        </Box>
      </Suspense>
    </div>
  );
};

export default OptimizedTabPanel;
